export const tuple = <T>(value: [T, T]) => value

export const getObjectKeys = <T extends object>(obj: T): (keyof T)[] => {
  return Object.keys(obj) as (keyof T)[]
}

export const buildObjectFromEntries = <
  K extends string,
  V,
  Complete extends boolean = false
>(
  entries: [K, V][],
  // Complete is only used for type inference
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  complete?: Complete
): Complete extends true ? Record<K, V> : { [P in K]?: V } => {
  return Object.fromEntries(entries) as any
}

export type PropsOf<C> = C extends new (...args: any[]) => { $props: infer P }
  ? P
  : never
